/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
var Viewmodel = function (options) {
  this.stepIndex = ko.observable(options.stepIndex);
  this.maxAvailabeStepIndex = ko.observable(this.stepIndex());
  this.isLast = ko.computed(function () {
    return this.stepIndex() === options.steps.length - 1;
  }, this);
  this.currentStep = ko.computed(function () {
    return options.steps[this.stepIndex()];
  }, this);
  var customBtnVisibleCriteria = {
    'last': ko.computed(function () {
      return this.isLast();
    }, this),
    'allButLast': ko.computed(function () {
      return !this.isLast();
    }, this)
  };
  this.customButtons = ko.observableArray(options.customButtons);
  this.customButtons().forEach((function (customBtn) {
    if (!_.isFunction(customBtn.visible)) {
      customBtn.isVisible = customBtnVisibleCriteria[customBtn.visible];
    } else {
      customBtn.isVisible = ko.computed(customBtn.visible, this);
    }
  }).bind(this));
  this.customButtons().forEach((function (customBtn) {
    if (!_.isFunction(customBtn.enable)) {
      customBtn.isEnable = _.isUndefined(customBtn.enable) || customBtn.enable;
    } else {
      customBtn.isEnable = ko.computed(customBtn.enable);
    }
  }).bind(this));
  this.showCancelBtn = ko.observable(options.showCancelBtn);
};
export default Viewmodel;

